import type {ReactElement} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import {Fragment} from 'react'
//import {useQuery} from 'react-query'
import toast from 'react-hot-toast'
import CustomToast from '../CustomToast'

import * as fbq from '@/services/fbpixel'
import React from 'react'
import {useRouter} from 'next/router'
import {useCartState} from '@/contexts/CartContext'
import {event} from 'nextjs-google-analytics'
import { useTranslation } from 'next-i18next'
import { track } from '@/lib/tracker'
type Props = {
  isOpen: boolean
  setIsOpen: (arg0: boolean) => void
  onProceed?: () => void
}
export default function CartConfirmationModal({
  isOpen,
  setIsOpen,
  onProceed,
}: Props): ReactElement {
  const {t} = useTranslation('personalizeModal');
  const {locale} = useRouter();
  const closeModal = () => {
    setIsOpen(false)
  }

  const cart = useCartState()
  const router = useRouter()
  const [isChecked, setIsChecked] = React.useState(false)
  //const [isChecked, setIsChecked] = React.useState(true)
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-[150]" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto" dir={`${locale === 'ar' ? 'rtl' : 'ltr'}`}>
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95">
              <Dialog.Panel className="w-full max-w-md xl:max-w-2xl transform overflow-hidden rounded-2xl bg-white text-left align-middle shadow-xl transition-all">
                <Dialog.Title className="text-lg font-medium px-4 pt-4">
                  <div className="flex justify-end items-end"></div>
                </Dialog.Title>
                <div className="modal-content p-2 md:p-6 pt-0 ">
                  <div className="confirmation-modal flex flex-col items-center justify-center">
                    <div className="confirmation-question my-4">
                      <svg
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6C14.0589 6 6 14.0589 6 24C6 33.9411 14.0589 42 24 42Z"
                          stroke="#0CDFBF"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M24 36C25.2426 36 26.25 34.9926 26.25 33.75C26.25 32.5074 25.2426 31.5 24 31.5C22.7574 31.5 21.75 32.5074 21.75 33.75C21.75 34.9926 22.7574 36 24 36Z"
                          fill="#0CDFBF"
                        />
                        <path
                          d="M24 27V25.5C25.0384 25.5 26.0534 25.1921 26.9167 24.6152C27.7801 24.0383 28.453 23.2184 28.8504 22.2591C29.2477 21.2998 29.3517 20.2442 29.1491 19.2258C28.9466 18.2074 28.4465 17.2719 27.7123 16.5377C26.9781 15.8035 26.0426 15.3035 25.0242 15.1009C24.0058 14.8983 22.9502 15.0023 21.9909 15.3996C21.0316 15.797 20.2117 16.4699 19.6348 17.3333C19.0579 18.1966 18.75 19.2117 18.75 20.25"
                          stroke="#0CDFBF"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <h2 className="font-semibold text-sm md:text-lg text-center">
                      {t('cartConfirmationHeading')}
                    </h2>
                    <p className="text-center text-xs md:text-base text-gray-500 mt-3">
                      {t('cartConfirmationSubHeading')}
                    </p>
                    <div className="checkbox flex justify-center items-center text-primary-500 mt-4">
                      <input
                        type="checkbox"
                        className={`rounded-sm ${locale === 'ar' ? 'ml-3' : 'mr-3'} text-primary focus:ring-primary-500 focus:ring-2 `}
                        name="confirmation"
                        id="confirmation"
                        checked={isChecked}
                        onChange={() => {
                          setIsChecked(!isChecked)
                        }}
                      />
                      <label
                        className={`text-xs md:text-sm ${locale === 'ar' ? "text-right" : "text-left"}`}
                        htmlFor="confirmation">
                        {t('cartConfirmationText')}
                      </label>
                    </div>
                    <div className="flex items-center justify-center w-full max-w-lg mt-4">
                      <button
                        onClick={() => {
                          if (!isChecked) {
                            toast.custom((tel) => <CustomToast t={tel} message={`${t('notCheckedError')}`} type='error' />);
                            return
                          }
                          closeModal()
                          if (onProceed) onProceed()
                          event('begin_checkout', {
                            currency: 'ILS',
                            value: cart.total,
                          })
                          track({event_name: 'begin_checkout'})
                          fbq.event('InitiateCheckout', {
                            num_items: cart.items.length,
                          })
                          router.push('/cart/address')
                        }}
                        className="w-full mt-4 flex items-center justify-center bg-success-500 text-white py-[.55rem] text-[18px] rounded-md
            transition ease-in-out duration-200 disabled:cursor-not-allowed
            disabled:opacity-75 font-semibold
            focus:ring-success-100 focus:ring-4 px-2">
                        {t('cartConfirmationYes')}
                      </button>

                      <button
                        onClick={() => {
                          closeModal()
                        }}
                        className={`w-full mt-4 flex items-center justify-center bg-red text-white py-[.55rem] text-[18px] rounded-md
            transition ease-in-out duration-200 disabled:cursor-not-allowed
            disabled:opacity-75 font-semibold
            focus:ring-4 px-2 ${locale === 'ar' ? 'mr-6' : 'ml-6' }`}>
                        {t('cartConfirmationNo')}
                      </button>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
